/*
 * TooltipHover
 *
 * A wrapper for Tooltip component, to enable it to be shown when hovered.
 */

import TooltipHover from "./TooltipHover.styled";
export default TooltipHover;
